/* global axios */
import ApiClient from '../ApiClient';

class WhatsappChannel extends ApiClient {
  constructor() {
    super('whatsapp', { accountScoped: true });
  }

  createEmbeddedSignup(params) {
    return axios.post(`${this.baseUrl()}/whatsapp/authorization`, params);
  }

  getMigrationSources() {
    return axios.get(
      `${this.baseUrl()}/whatsapp/authorization/migration_sources`
    );
  }

  migrateInbox({ sourceInboxId, targetInboxId }) {
    return axios.post(`${this.baseUrl()}/whatsapp/authorization/migrate`, {
      source_inbox_id: sourceInboxId,
      target_inbox_id: targetInboxId,
    });
  }

  reauthorizeWhatsApp({ inboxId, ...params }) {
    return axios.post(`${this.baseUrl()}/whatsapp/authorization`, {
      ...params,
      inbox_id: inboxId,
    });
  }
}

export default new WhatsappChannel();
